import { InstructionsModal } from './InstructionsModal';
export default InstructionsModal;
